import { cn } from "@shared/ui/utils";

import CubeIcon from "~/assets/svg/cube.svg";
import { Cube as CubeType } from "./use-onboarding-cubes";

export const Cube = ({ isActive, isVisible }: CubeType) => {
  return (
    <div
      style={{
        pointerEvents: isVisible ? "auto" : "none",
      }}
      className={cn("-mr-[1px]", isVisible ? "opacity-100" : "opacity-0")}
    >
      <CubeIcon state={isActive ? "active" : "inactive"} />
    </div>
  );
};
